import { render } from "./tax_advantage_section.html?vue&type=template&id=24497612&external"
import script from "./tax_advantage_section.js?vue&type=script&lang=js&external"
export * from "./tax_advantage_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__